/** A small disclosure chevron; rotates when its <details> parent is [open]. */
export function Chevron() {
  return (
    <span className='chev' aria-hidden='true'>
      <svg width='16' height='16' viewBox='0 0 16 16'>
        <path
          d='M6 3l5 5-5 5'
          stroke='currentColor'
          strokeWidth='1.6'
          fill='none'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </span>
  )
}
